import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { organisationStatusBackground } from '@organisations/classes/utilities';
import { IUserAndOrganisationUser } from '@organisations/models/organisation-user';
import { IOrganisation } from '@organisations/models/organisations';
import { ModalService } from '@shared/services/modal/modal.service';

import { AddUserModalComponent } from '../modals/add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '../modals/edit-user-modal/edit-user-modal.component';

@Component({
	selector: 'app-mobile-org-users-table',
	imports: [CommonModule],
	templateUrl: './mobile-org-users-table.component.html',
	styleUrl: './mobile-org-users-table.component.scss',
})
export class MobileOrgUsersTableComponent {
	@Input() organisationMembers: Array<IUserAndOrganisationUser>;
	@Input() organisation: IOrganisation;

	private modalService = inject(ModalService);

	openInviteUser(): void {
		this.modalService.open(AddUserModalComponent);
	}

	openEditUser(member: IUserAndOrganisationUser): void {
		const modelRef = this.modalService.open(EditUserModalComponent);
		const componentInstance = modelRef.componentInstance as EditUserModalComponent;
		componentInstance.userAndOrganisationUser = member;
		componentInstance.organisation = this.organisation;
	}

	organisationStatusBackground(member: IUserAndOrganisationUser) {
		return organisationStatusBackground(member);
	}
}
